import { createFeatureSelector, createSelector } from '@ngrx/store';
import { envFeatureKey, State } from './env.reducer';

export const selectEnvFeature = createFeatureSelector<State>(envFeatureKey);

export const isLoading = createSelector(selectEnvFeature, (state) => state.isLoading);

export const selectEnvironment = createSelector(selectEnvFeature, (state) => state.environment);

export const networkIsOnline = createSelector(selectEnvFeature, (state) => state.online);

export const appIsInBackground = createSelector(selectEnvFeature, (state) => state.backgroundMode);
